import {
    textNumber,
    textRate,
    map
} from "../../../../common/utils";
import { nColor } from "./utils";

// 蜡烛图
export function formatTipCandle(klines,
    dataIndex, {
        maDays,
        colors
    }) {
    const Today = klines[dataIndex]
    const Yesterday = klines[dataIndex - 1]
    const prevClose = Yesterday ? Yesterday.close : Today.close
    maDays = map(maDays, days => {
        const key = `ma${days}`
        return Today[key] ? `<dd><span style="color:${colors[key]}">MA${days}&nbsp;：${textNumber(Today[key], 2)}</span></dd>` : ''
    })

    return `<dl class="chart-tip">
<dt>第${dataIndex+1}天</dt>
<dd style="color: ${nColor( Today.highest - prevClose)}">高：${textNumber(Today.highest, 2)}<span class="cl_muted">/</span>${textRate((Today.highest - prevClose)/prevClose)}%</dd>
<dd style="color: ${nColor( Today.open - prevClose)}">开：${textNumber(Today.open, 2)}<span class="cl_muted">/</span>${textRate((Today.open - prevClose)/prevClose)}%</dd>
<dd style="color: ${nColor( Today.lowest - prevClose)}">低：${textNumber(Today.lowest, 2)}<span class="cl_muted">/</span>${textRate((Today.lowest - prevClose)/prevClose)}%</dd>
<dd style="color:${nColor(Today.close - prevClose)}">收：${textNumber(Today.close, 2)}<span class="cl_muted">/</span>${textRate((Today.close - prevClose)/prevClose)}%</dd>
${maDays.join('')}
</dl>`
}

// 成交量
export function formatTipVolume(klines,
    dataIndex, {
        colors
    }) {
    const Today = klines[dataIndex]
    const Yesterday = klines[dataIndex - 1]

    const chgPrice = Yesterday ?  Today.close - Yesterday.close : 0
    const volume = `<dd style="color:${nColor(chgPrice, colors)}">成交量：${textNumber(Today.volume)}</dd>`
    const turnRate = Today.turnRate > 0 ? `<dd>换手率：${textRate(Today.turnRate)}</dd>` : ''
    return `<dl class="chart-tip">${volume}${turnRate}</dl>`
}

// MACD
export function formatTipVolMacd(klines,
    dataIndex, {
        colors
    }) {
    const Today = klines[dataIndex]
    return `<dl class="chart-tip">
<dd style="color:${nColor(Today.macd, colors)}">MACD：${textNumber(Today.macd)}</dd>
<dd style="color:${colors.dif}">DIF：${textNumber(Today.dif)}</dd>
<dd style="color:${colors.dea}">DEA：${textNumber(Today.dea)}</dd>
</dl>`
}

// KDJ
export function formatTipVolKdj(klines,
    dataIndex, {
        colors
    }) {
    const Today = klines[dataIndex]
    return `<dl class="chart-tip">
<dd style="color:${colors.k}">K：${textNumber(Today.k)}</dd>
<dd style="color:${colors.d}">D：${textNumber(Today.d)}</dd>
<dd style="color:${colors.j}">J：${textNumber(Today.j)}</dd>
</dl>`
}
